'use strict';

var _MobileHeader = require('../models/global/MobileHeader');

var _MobileHeader2 = _interopRequireDefault(_MobileHeader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

document.addEventListener('DOMContentLoaded', function () {
  var mobileHeaderEl = document.querySelector('.js-mobileHeader');
  var mobileHeader = new _MobileHeader2.default(mobileHeaderEl);

  mobileHeader.init();
});